module.exports = __webpack_public_path__ + "static/img/icon-form-m_12.efd18162.svg";